const gridHeight = 52;
const numColumnsOfGrid = 24;
const breakPoints = [12, 6];
const addingTileSize = 5;

exports.gridHeight = gridHeight;
exports.numColumnsOfGrid = numColumnsOfGrid;
exports.breakPoints = breakPoints;
exports.addingTileSize = addingTileSize;
